export default "__VITE_ASSET__ookSsXuX__"